import "../App.css";

import { React, useState } from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Button from "@mui/joy/Button";
import { Form, Formik, Field, ErrorMessage } from "formik";
import {
  Avatar,
  Grid,
  Paper,
  Box,
  createTheme,
  TextField,
} from "@mui/material";
import background from "../login_bg.jpg";
import ConfirmDialog from "../dialog/ConfirmDialog";
import * as Yup from "yup";
import Axios from "../api/Axios";
import { useNavigate } from "react-router-dom";

const theme = createTheme();

const avatarStyle = { backgroundColor: "green", marginTop: "1vh" };

const titleStyle = { color: "#8d4004" };

const OTP = () => {
  const navigate = useNavigate();
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const imgStyle = {
    backgroundImage: `url(${background})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    width: "100vw",
    height: "100vh",
  };

  const buttonStyle = {
    marginLeft: "1vh",
    marginTop: "2vh",
    marginRight: "1vh",
    marginBottom: "3vh",
  };
  const usernameStyle = {
    marginLeft: "1vh",
    marginTop: "2vh",
    marginRight: "1vh",
    marginBottom: "1vh",
  };
  const passwordStyle = {
    marginLeft: "1vh",
    marginTop: "2.5vh",
    marginRight: "1vh",
    marginBottom: "1vh",
  };
  const typographyStyle = {
    marginLeft: "1vh",
    marginTop: "2vh",
    marginRight: "1vh",
    marginBottom: "1vh",
  };
  const otpStyle = {
    marginLeft: "1vh",
    marginTop: "2vh",
    marginRight: "1vh",
    marginBottom: "1vh",
  };

  const initialValues = {
    email: "",
  };
  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Please enter valid email").required("Required"),
  });

  const OTP_URL = "/api/v1/users/generate-password-reset-otp";
  const onSubmit = async (values, props) => {
    setConfirmDialog({ ...confirmDialog, isOpen: false });
    //setSubmitting(true)

    const email = values.email;

    try {
      const response = await Axios.post(
        OTP_URL,
        { email },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response.data.message);

      // clear input fields
      props.resetForm();
      props.setSubmitting(false);
      //setSubmitting(true);

      navigate("/reset-password", {
        replace: true,
        state: {
          email: email,
        },
      });
    } catch (error) {
      var errorMessage = "";
      if (error.response) {
        // The client was given an error response (5xx, 4xx)
        const errorData = error.response.data;
        errorMessage = errorData.message;
      } else if (error.request) {
        // The client never received a response, and the request was never left
        errorMessage = "No server response";
      } else {
        // Anything else
        errorMessage = "Unexpected error occurred";
      }
      setConfirmDialog({
        isOpen: true,
        title: "Request Failed",
        subTitle: errorMessage,
        action: "Retry",
        onConfirm: { onSubmit },
      });
    }
  };

  return (
    <div style={imgStyle}>
      <Box sx={{ display: "flex" }}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          <Paper
            elevation={10}
            sx={{
              marginLeft: { xs: 8, sm: 20, md: 28, lg: 74, xl: 64 }, // xs=iPhone SE; sm=iPad Mini; md=iPad pro; lg=Nest Hub Max
              marginRight: { xs: 7, sm: 20, md: 28, lg: 74, xl: 64 },
              marginTop: { xs: 6, sm: 6, md: 6, lg: 6, xl: 6 },
              marginBottom: 4,
              paddingLeft: theme.spacing(2),
              paddingTop: theme.spacing(2),
              paddingRight: theme.spacing(4),
              paddingBottom: theme.spacing(2),
            }}
          >
            <Grid align="center">
              <Avatar style={avatarStyle}>
                <LockOutlinedIcon></LockOutlinedIcon>
              </Avatar>

              <h2 style={titleStyle}>BuuKipa Tenant</h2>
              <h2>Forgot Password?</h2>
              <h5>Please enter the email you used to register</h5>

              <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
              >
                {(props) => (
                  <Form>
                    <Field
                      as={TextField}
                      label="Email"
                      name="email"
                      placeholder="Enter your email"
                      style={usernameStyle}
                      fullWidth
                      required
                      helperText={
                        <ErrorMessage name="email">
                          {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                        </ErrorMessage>
                      }
                    />

                    <Button
                      type="submit"
                      color="primary"
                      fullWidth
                      loading={props.isSubmitting}
                      loadingPosition="start"
                      variant="solid"
                      style={buttonStyle}
                    >
                      {props.isSubmitting ? "Processing" : "Continue"}
                    </Button>
                  </Form>
                )}
              </Formik>
            </Grid>
          </Paper>
        </Grid>

        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
      </Box>
    </div>
  );
};

export default OTP;
